// Kedve — signature programs and content

export const ACCELERATORS = [
  {
    id: "client-ready",
    title: "Client-Ready Professional",
    outcome: "Become job-ready for any client-facing corporate role.",
    idealFor: ["Fresh Graduates", "Early-Career Professionals", "Career Switchers"],
  },
  {
    id: "business-communication",
    title: "Business Communication Mastery",
    outcome: "Speak, write and present with confidence.",
    idealFor: ["Individual Contributors", "First-Time Managers", "Anyone preparing to present to leaders"],
  },
  {
    id: "relationship-stakeholder",
    title: "Relationship & Stakeholder Mastery",
    outcome: "Build trust and influence across teams and customers.",
    idealFor: ["Managers", "Cross-functional Leads", "Consultants & Advisors"],
  },
  {
    id: "strategic-account",
    title: "Strategic Account Excellence",
    outcome: "Own customer relationships, reviews and business growth.",
    idealFor: ["Account Managers", "Customer Success Leads", "Client Partners"],
  },
  {
    id: "enterprise-client",
    title: "Enterprise Client Leadership",
    outcome: "Lead enterprise customers and strategic programs.",
    idealFor: ["Senior Account Executives", "Program Leads", "Enterprise Sales Leaders"],
  },
  {
    id: "commercial-business",
    title: "Commercial & Business Leadership",
    outcome: "Think commercially and own business outcomes.",
    idealFor: ["Product & Ops Leaders", "Non-commercial Leaders", "Managers preparing for P&L"],
  },
  {
    id: "executive-partner",
    title: "Executive Partner Program",
    outcome: "Become a trusted advisor to CXOs and boards.",
    idealFor: ["Senior Managers & Directors", "Advisors to Executives", "Chiefs of Staff"],
  },
  {
    id: "enterprise-fellowship",
    title: "Enterprise Leadership Fellowship",
    outcome: "Build an executive mindset through a live business transformation project.",
    idealFor: ["Vice Presidents & Heads of Function", "General Managers", "Founders & Senior Consultants"],
  },
];

export const JOURNEY_STAGES = [
  { code: "01", title: "Start", body: "See your career clearly. Where you stand today, and what the next room asks of you." },
  { code: "02", title: "Launch", body: "Move from proving competence to demonstrating judgement. Speak with clarity. Write with weight." },
  { code: "03", title: "Build", body: "Lead work that outlives you. Learn the operating cadence of a person who ships without permission." },
  { code: "04", title: "Grow", body: "Influence peers, sponsors and skeptics. Turn output into visibility, and visibility into trust." },
  { code: "05", title: "Lead", body: "Move organisations that do not report to you. Set the terms of the room before it opens." },
  { code: "06", title: "Influence", body: "Become the decision the business waits for. Executives ask what you think. Peers read what you write." },
  { code: "07", title: "Transform", body: "Redefine the standard for your role and your industry. Available. Not required. Not for everyone." },
];

export const COMMUNITY_STATS = [
  { number: "94", label: "Countries" },
  { number: "3,200", label: "Professionals in residence" },
  { number: "42", label: "Business partners" },
  { number: "6", label: "Global chapters" },
];

export const CAPABILITIES = [
  { label: "Communication", tagline: "The precision to be understood." },
  { label: "Leadership", tagline: "The gravity to be followed." },
  { label: "Executive Presence", tagline: "The composure to be trusted." },
  { label: "Commercial Thinking", tagline: "The judgement to see beyond a role." },
  { label: "Decision Making", tagline: "The clarity to move quickly." },
  { label: "Influence", tagline: "The signal to be listened to." },
  { label: "Stakeholder Management", tagline: "The architecture of relationships." },
];

export const METHOD_STEPS = [
  { word: "Learn", body: "In small live rooms, from people who have done the work." },
  { word: "Practice", body: "Rehearse the moment before you understand its theory." },
  { word: "Apply", body: "Take it into your next real conversation the same week." },
  { word: "Lead", body: "Return with a room that responds to you differently." },
];
